import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import { userTravelRecords, userTravelDetailsRecords, userPassportDetailsRecords } from '../../services/common/states';
import { useNavigate } from 'react-router';
import { setTravelTab } from '../../services/store/userSlice';
import { useDispatch } from 'react-redux';
import { Card } from 'react-bootstrap';
import { travelService } from '../../services/extensions';
import TravelDataTable from './travel-datatable';
import { Dialog } from "primereact/dialog";
const InsuranceDetails = () => {
    const dispatch = useDispatch();
    const [TravelRecords, setUserTravelRecords] = useState({});
    const [travelDetailsRecords, setTravelDetailsRecords] = useState({});
    const [passportDetailsRecords, setPassportDetailsRecords] = useState({});
    const [insuranceData, setInsuranceData] = useState({});


    const [visible, setVisible] = useState(false);
    useEffect(() => {
        userTravelRecords.subscribe((result) => {
            if (result) {
                setUserTravelRecords(result);
            }
        });
        userTravelDetailsRecords.subscribe((result) => {
            if (result) {
                setTravelDetailsRecords(result);
            }
        });
        userPassportDetailsRecords.subscribe((result) => {
            if (result) {
                setPassportDetailsRecords(result);
            }
        });
    }, [])
    const searchForm = useFormik({
        initialValues: {
            currentResidenceAddress: '',
            nomineeName: '',
            relationWithNominee: ''
        },
        validate: (data) => {
            let errors = {};
            if (!data.currentResidenceAddress) {
                errors.currentResidenceAddress = 'Enter Current Residence Address';
            }
            if (!data.nomineeName) {
                errors.nomineeName = 'Enter Nominee Name';
            }
            if (!data.relationWithNominee) {
                errors.relationWithNominee = 'Enter Nominee Relation';
            }
            return errors;
        },
        onSubmit: (data) => {
            setVisible(true)
            setInsuranceData(data)
            // saveUserTravelRecords(data)
        },
    });

    const isFormFieldValid = (name) =>
        !!(searchForm.touched[name] && searchForm.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{searchForm.errors[name]}</small>
            )
        );
    };

    const saveUserTravelRecords = (data) => {
        let params = {
            travel: {
                travellerName: TravelRecords.travellerName,
                travellerInitiatedBy: TravelRecords.travellerInitiatedBy,
                comment: TravelRecords.travellercomment,
                emailId: TravelRecords.emailId,
                givenName: TravelRecords.givenName,
                empEcn: TravelRecords.userecn,
                managerEcn: TravelRecords.managerecn,
                reason: TravelRecords.reason,
                mobileNumber: TravelRecords.mobileNumber,
                selectedDesignation: TravelRecords.selectedDesignation,
                tripType: TravelRecords.selectedTripType,
                visaType: TravelRecords.selectedVisaType,
                surname: TravelRecords.surname,
                grade: TravelRecords.Grade,
                mealRequest: travelDetailsRecords.mealRequest,
                clientId: travelDetailsRecords.clientName,
                projectId: travelDetailsRecords.projectName,
                costCenter: travelDetailsRecords.costCentre,
                buHead: travelDetailsRecords.buFunctionalHead,
                countryofVisit: travelDetailsRecords.countryOfVisit,
                states: travelDetailsRecords.stateCities,
                daCurrency: travelDetailsRecords.daCurrency,
                daentitleAmmount: travelDetailsRecords.daEntitleAmount,
                frequentflyerNumber: travelDetailsRecords.frequentFlyerNumber,
                journeyDate: travelDetailsRecords.journeyDate,
                projectManager: travelDetailsRecords.projectManager,
                projectName: travelDetailsRecords.projectName,
                returnDate: travelDetailsRecords.returnDate,
                seatRequest: travelDetailsRecords.seatRequest,
                stateCities: travelDetailsRecords.stateCities,

            },
            travelDetails: {
                currentResidenceAddress: insuranceData?.currentResidenceAddress,
                nomineeName: insuranceData?.nomineeName,
                relationWithNominee: insuranceData?.relationWithNominee,
                passportNumber: passportDetailsRecords.passportNumber,
                dateOfBirth: passportDetailsRecords.dateOfBirth,
                placeOfIssue: passportDetailsRecords.placeOfIssue,
                addressAsPerthefPassport: passportDetailsRecords.addressAsPerPassport,
                dateOfexpireOfPassport: passportDetailsRecords.dateOfExpire,
                dateOfIssueOfPassport: passportDetailsRecords.dateOfIssue,
            }
        }
        travelService.createTravelAndDetails(params).then(resp => {
            if (resp.data.success) {
                toast.success("travel request created sucessfully");
                dispatch(setTravelTab(0));
                setVisible(false);
            }
        })
    };

    return (
        <div className="tabview-demo">
            <form onSubmit={searchForm.handleSubmit} autoComplete='off'>
                <Panel>
                    <div className="formgrid grid">


                        <div className="field col-6">
                            <label htmlFor="Nominee Name<" className="font-bold block mb-2">Nominee Name</label>
                            <InputText
                                id="nomineeName"
                                name="nomineeName"
                                type="text"
                                placeholder="Nominee Name"
                                value={searchForm.values.nomineeName}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("nomineeName")}
                        </div>


                        <div className="field col-6">
                            <label htmlFor="Relation With Nominee<" className="font-bold block mb-2">Relation With Nominee</label>
                            <InputText
                                id="relationWithNominee"
                                name="relationWithNominee"
                                type="text"
                                placeholder="Relation With Nominee"
                                value={searchForm.values.relationWithNominee}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("relationWithNominee")}
                        </div>
                        <div className="field col-12">
                            <label htmlFor="Current Residence Address" className="font-bold block mb-2">Current Residence Address</label>
                            <InputTextarea
                                id="currentResidenceAddress"
                                name="currentResidenceAddress"
                                placeholder="Current Residence Address"
                                value={searchForm.values.currentResidenceAddress}
                                onChange={searchForm.handleChange}
                                rows={7}
                                maxLength={150}
                                className="w-100"
                            />
                            {getFormErrorMessage("currentResidenceAddress")}
                            <span style={{ float: "right" }}>150 Characters Left</span>
                        </div>
                    </div>
                </Panel>
                <Panel>
                    <div className="formgrid grid">
                        {/* <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Previous" icon="pi pi-arrow-circle-left" aria-label="Save" severity="secondary" type='submit' />
                        </div> */}
                        {/* <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save as draft " icon="pi pi-inbox" aria-label="Save" severity="primary" type='submit' />
                        </div> */}
                        <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save & Submit" icon="pi pi-check" severity="warning" />
                        </div>
                    </div>
                </Panel>
            </form>
            <Panel>
                <TravelDataTable />
            </Panel>
            {/* <Panel>
                <Button label='Delete All' icon="pi pi-trash" className='mr-2' severity='danger' />
                <Button label="Save & Submit" icon="pi pi-check" />
            </Panel> */}


            <Dialog header="Travel Detail" className="pop-up-dialog add-timesheet custom_popup" visible={visible} style={{ width: '95vw' }} onHide={() => setVisible(false)}>
                <div>
                    <Panel className='traveldetail'>
                        <div className='formgrid grid'>
                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Traveler Detail</h1>
                                        <button className='link'>
                                            <i className='pi pi-pencil' onClick={() => dispatch(setTravelTab(0))}></i>
                                        </button>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-2 single-category'>
                                            <h2>Trip Type</h2>
                                            <p>{TravelRecords.selectedTripType}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Visa Type</h2>
                                            <p>{TravelRecords.selectedVisaType}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>User ECN </h2>
                                            <p>{TravelRecords.userecn}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Manager ECN </h2>
                                            <p>
                                                {TravelRecords.managerecn}
                                            </p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Traveller Name</h2>
                                            <p>{TravelRecords.travellerName}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Traveller Initiated By</h2>
                                            <p>{TravelRecords.travellerInitiatedBy}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Surname</h2>
                                            <p>{TravelRecords.surname}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Given Name</h2>
                                            <p>{TravelRecords.givenName}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Designation</h2>
                                            <p>{TravelRecords.selectedDesignation}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Mobile Number</h2>
                                            <p>{TravelRecords.mobileNumber}</p>
                                        </div>
                                        <div className='field col-4 single-category'>
                                            <h2>Email ID</h2>
                                            <p>{TravelRecords.emailId}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Grade</h2>
                                            <p>{TravelRecords.Grade}</p>
                                        </div>
                                        <div className='field col-6 single-category'>
                                            <h2>Traveller Comments</h2>
                                            <p>{TravelRecords.travellerName}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Travel Detail</h1>
                                        <button className='link'>
                                            <i className='pi pi-pencil' onClick={() => dispatch(setTravelTab(1))}></i>
                                        </button>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-2 single-category'>
                                            <h2>Client Name</h2>
                                            <p>{travelDetailsRecords.clientName}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Project Name</h2>
                                            <p>{travelDetailsRecords.projectName}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Project Manager</h2>
                                            <p>{travelDetailsRecords.projectManager}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>BU/Functional Head</h2>
                                            <p>{travelDetailsRecords.buFunctionalHead}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Country of visit</h2>
                                            <p>{travelDetailsRecords.countryOfVisit}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>State/Cities</h2>
                                            <p>{travelDetailsRecords.stateCities}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Journey Date</h2>
                                            <p>{travelDetailsRecords.journeyDate}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Return Date</h2>
                                            <p>{travelDetailsRecords.returnDate}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Cost Center</h2>
                                            <p>{travelDetailsRecords.costCentre}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>DA Currency</h2>
                                            <p>{travelDetailsRecords.daCurrency} </p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2> DA Entitle Amount</h2>
                                            <p>{travelDetailsRecords.daEntitleAmount}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Seat Request</h2>
                                            <p>{travelDetailsRecords.seatRequest}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Meal Request</h2>
                                            <p>{travelDetailsRecords.mealRequest}</p>
                                        </div>
                                        <div className='field col-6 single-category'>
                                            <h2>Frequently Flyer Number</h2>
                                            <p>{travelDetailsRecords.frequentFlyerNumber}</p>
                                        </div>

                                    </div>
                                </Card>
                            </div>


                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Passport Detail</h1>
                                        <button className='link'>
                                            <i className='pi pi-pencil' onClick={() => dispatch(setTravelTab(2))}></i>
                                        </button>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-2 single-category'>
                                            <h2>Passport Number</h2>
                                            <p>{passportDetailsRecords.passportNumber}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Date of Birth</h2>
                                            <p>{passportDetailsRecords.dateOfBirth}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Place of Issue</h2>
                                            <p>{passportDetailsRecords.placeOfIssue}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Issue of Passport</h2>
                                            <p>{passportDetailsRecords.dateOfIssue}</p>
                                        </div>
                                        <div className='field col-2 single-category'>
                                            <h2>Expire In Passport</h2>
                                            <p>{passportDetailsRecords.dateOfExpire}</p>
                                        </div>
                                        <div className='field col-6 single-category'>
                                            <h2>Address as per the Passport</h2>
                                            <p>{passportDetailsRecords.addressAsPerPassport}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Insurance Detail</h1>
                                        <button className='link'>
                                            <i className='pi pi-pencil' onClick={() => setVisible(false)}></i>
                                        </button>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-4 single-category'>
                                            <h2>Current Residence Address</h2>
                                            <p>{insuranceData?.currentResidenceAddress}</p>
                                        </div>
                                        <div className='field col-4 single-category'>
                                            <h2>Nominee Name</h2>
                                            <p>{insuranceData?.nomineeName}</p>
                                        </div>
                                        <div className='field col-4 single-category'>
                                            <h2>Relation With Nominee</h2>
                                            <p>{insuranceData?.relationWithNominee}</p>
                                        </div>

                                    </div>
                                </Card>
                            </div>

                        </div>
                    </Panel>
                    <div className="relative-container">
                        <Button className="button-right" label='Save and Submit' onClick={() => saveUserTravelRecords()}></Button>
                    </div>
                </div>
            </Dialog>





        </div>
    )
}
export default InsuranceDetails;